<template>
  <transition name="fade">
    <div v-if="isShow" class="allScreen" :style="[style]">
      <div>
        <span>{{percent}}</span>%
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data: function() {
    return {
      style: {
        zIndex: this.zIndex
      },
      count: 0,
      percent: 0,
      prevNum: 0,
      isShow: this.showCover
    };
  },
  props: {
    arrImg: {
      type: Array,
      default: () => []
    },
    zIndex: {
      type: Number,
      default: 999999
    },
    showCover: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    loading() {
      console.log(this.$browser.height());
      for (let i = 0; i < this.arrImg.length; i++) {
        let img = new Image();

        img.onload = () => {
          this.maincode();
        };
        img.onerror = () => {
          let obj = {
            text: this.arrImg[i]
          };
          this.$emit("errorimg", obj);
          this.maincode();
        };
        img.src = this.arrImg[i];
      }
    },
    maincode() {
      this.count++;
      this.percent = this.$method.fomatFloat(
        (this.count * 100) / this.arrImg.length,
        2
      );
      if (this.prevNum !== this.percent) {
        this.$emit("callback", this.percent);
        this.prevNum = this.percent;
        if (this.percent >= 100) {
          this.$emit("complete", 100);
          setTimeout(() => {
            this.isShow = false;
          }, 1);
        }
      }
    }
  },
  mounted() {
    this.loading();
  }
};
</script>

<style scoped>
.allScreen {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: #f3f3f3;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingImg.vue